import { MarketName } from "@/constants/marketName"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    agreement: graphql(`
        fragment sortAgreements_Agreement on AgreementType {
            isActive
            supplyPoint {
                marketName
            }
        }
    `),
}

export function sortAgreements(
    a: FragmentOf<typeof graphQLFragments.agreement>,
    b: FragmentOf<typeof graphQLFragments.agreement>
) {
    const agreementA = readFragment(graphQLFragments.agreement, a)
    const agreementB = readFragment(graphQLFragments.agreement, b)

    if (agreementA.isActive !== agreementB.isActive) {
        return agreementA.isActive ? -1 : 1
    }

    if (agreementA.supplyPoint?.marketName !== agreementB.supplyPoint?.marketName) {
        return agreementA.supplyPoint?.marketName === MarketName.FRA_ELECTRICITY ? -1 : 1
    }

    return 0
}

sortAgreements.fragments = graphQLFragments
